export default __webpack_public_path__ + "static/media/default.74976c38.svg";